"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactBootstrap = require("react-bootstrap");
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const AuthDropdown = _ref => {
  let {
    item
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_reactBootstrap.OverlayTrigger, {
    key: item.slug,
    placement: "bottom",
    delay: {
      show: 1000,
      hide: 100
    },
    overlay: /*#__PURE__*/_react.default.createElement(_reactBootstrap.Tooltip, {
      id: `tooltip-${item.slug}`,
      className: `${item.iconOnly == true ? 'mm-desktop-only' : 'hide-tooltip'}`
    }, item.title)
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Dropdown, {
    key: item.title,
    className: "nav-item"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Dropdown.Toggle, {
    variant: "none",
    id: `collapsible-nav-dropdown-${item.slug}`,
    className: `mm-nav-dropdown--${item.iconClass} nav-link`
  }, item.iconClass == 'user' && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("picture", {
    className: `mm-nav-icon--${item.iconClass}`
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: `${item.photoUrl || item.iconUrl}`,
    alt: "",
    "data-testid": "user-avatar"
  })), /*#__PURE__*/_react.default.createElement("span", {
    className: `${item.iconOnly ? 'sr-nav' : ''}`
  }, item.title)), item.iconClass != 'user' && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
    className: `mm-nav-icon--${item.iconClass}`
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: `${item.iconOnly ? 'sr-nav' : ''}`
  }, item.title)), item.iconClass == 'notification' && item.hasNotice && /*#__PURE__*/_react.default.createElement("span", {
    className: "badge badge-indicator"
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Dropdown.Menu, {
    align: `${item.dropdownRight ? 'right' : ''}`
  }, item.dropdownContent.map((content, index) => {
    return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Dropdown.Item, {
      eventKey: index,
      href: content.path,
      id: `auth_nav_${content.slug}`,
      key: content.slug
    }, /*#__PURE__*/_react.default.createElement("span", null, content.title));
  }))));
};
AuthDropdown.propTypes = {
  item: _propTypes.default.shape({
    title: _propTypes.default.string,
    slug: _propTypes.default.string,
    iconOnly: _propTypes.default.bool,
    iconClass: _propTypes.default.string,
    iconUrl: _propTypes.default.string,
    hasNotice: _propTypes.default.bool,
    hasPhoto: _propTypes.default.bool,
    photoUrl: _propTypes.default.string,
    dropdownRight: _propTypes.default.bool,
    dropdownContent: _propTypes.default.arrayOf(_propTypes.default.shape({
      title: _propTypes.default.string,
      path: _propTypes.default.string,
      slug: _propTypes.default.string
    }))
  })
};
var _default = exports.default = AuthDropdown;